import { Component, Output, Input, EventEmitter } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { ITrackerFilter, Retailer } from '../../../entities/index';

@Component({
  selector: 'app-tracker-filters',
  templateUrl: './tracker-filters.html'
})
export class TrackerFilterComponent {
  
  TrackerFilter: ITrackerFilter;
  inputValue: string;
  applyOff: boolean = true; // Disable or Enable boutton apply
  deletedOff: boolean = true; // Disable or Enable boutton deleted
  retailerId: number;
  retailers: Promise<Retailer[]>;
  boxOne: boolean = false;


  @Output()
  resultTrackerFilter: EventEmitter<ITrackerFilter> = new EventEmitter<ITrackerFilter>();

  constructor(protected notification: NotificationsService){}

  // Active for keyup, save the retailer id 
  async keySave(e): Promise<void> {

   
    let name = e.target.value; // Retrieve the entered value
    this.deletedOff = false; // Enable boutton deleted

    // Compare the name entered with the names in the list to find retailer 
    const retailer = (await this.retailers).find((x:Retailer) =>  x.name === name )

    // If exist default color in box input
    if(retailer){
      document.getElementById("retailer-input").style.background = "rgba(0,0,0,0)";
      this.retailerId = retailer.id;
      this.applyOff = false; // Enable boutton apply

    // If not exist, red color in box input
    }else{
      document.getElementById("retailer-input").style.background = "rgba(255,0,0,0.466)";
      this.retailerId = null;
      this.applyOff = true; // Disable boutton apply
    }
  }          

  @Log('blue')
  // Active fot ngSubmit Boutton Save, emit TrackerFilter in resultTrackerFilter
  save() {
    this.TrackerFilter = new ITrackerFilter();
    this.TrackerFilter.retailer_id = this.retailerId;
    this.resultTrackerFilter.emit(this.TrackerFilter);
    this.applyOff = true; // Disable boutton apply
  }

  // Active fot click Boutton +/- in BoxCollapse
  collapsed(){

    // Close BoxCollapse 
    if(this.boxOne){
      this.boxOne = false;

      // Deleted the text input area
      this.inputValue = "";

      // Deleted all value 
      if(this.TrackerFilter){
        this.deleted();
      }

    // Open BoxCollapse 
    }else{
      this.boxOne = true;
    }
  }

  @Log('blue')
  deleted() {
    // Default color in box input
    document.getElementById("retailer-input").style.background = "rgba(0,0,0,0)"

    // Deleted the text input area
    this.inputValue = ""; 

    // No filter
    this.TrackerFilter = null
    this.applyOff = true; // Disable boutton apply
    this.deletedOff = true; // Disable boutton deleted

    // Emit filter is null
    this.resultTrackerFilter.emit(this.TrackerFilter);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/tracker-filter/tracker-filters.component.ts